import { useContext } from 'react';
import { AppContext } from '../App';
import Orgs from '../components/orgs/Orgs';
import TopBar from '../components/common/TopBar';
import { useSetTitle } from '../components/hooks/useSetTitle';
import useSetOrgFromParams from '../components/hooks/useSetOrgFromParams';

export interface OrgPageProps {}

const OrgPage: React.FC<OrgPageProps> = () => {
  const { orgLabel, dataPoolLabel } = useContext(AppContext);

  // Set org context from URL params when navigating directly to /organization/:orgId
  useSetOrgFromParams();

  useSetTitle(orgLabel ? `Data Pools - ${orgLabel}` : `Orgs: All`);

  return (
    <div id="org-page" style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      <TopBar />
      <Orgs />
    </div>
  );
};

export default OrgPage;
